var _defs, _g, _circle, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconRenovationModernisationV23(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 94.7 104.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#010101;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_renovation-modernisation_v2.3.4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2",
    "data-name": "Ebene 1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "house"
  }, /*#__PURE__*/React.createElement("g", {
    id: "house-2"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "52.68 28.66 84.21 54.13 78.63 49.72 78.63 92.19 56.11 92.19"
  })), /*#__PURE__*/React.createElement("g", {
    id: "house-2-2",
    "data-name": "house-2"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "38.59 92.19 16.07 92.19 16.17 78.43 19.02 73.13 16.23 69.79 16.23 62.67"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "42.02 28.65 10.49 54.12 16.07 49.71 16.1 51.95 17.96 55.28 16.18 58.91 16.23 63.14"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "31.09 37.32 31.09 28.59 23.26 28.59 23.26 31.6 25.37 35.16 23.27 38.48 23.29 43.77"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 16.55,
    y1: 88.05,
    x2: 34.86,
    y2: 88.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 16.55,
    y1: 84.09,
    x2: 28.61,
    y2: 84.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 21.06,
    y1: 84.09,
    x2: 21.06,
    y2: 80.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 21.06,
    y1: 88.05,
    x2: 21.06,
    y2: 91.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 26.28,
    y1: 87.96,
    x2: 26.28,
    y2: 84.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 30.75,
    y1: 91.56,
    x2: 30.75,
    y2: 88.05
  }))), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 47.06,
    y1: 69.23,
    x2: 47.16,
    y2: 98.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 47.06,
    y1: 16.13,
    x2: 47.06,
    y2: 53.03
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "57.29 69.07 65.22 61.6 57.29 54.04 65.22 61.6 31.73 61.6"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 78.09,
    cy: 18.61,
    r: 3.75
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 81.17,
    y1: 25.29,
    x2: 83.79,
    y2: 30.77
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 84.99,
    y1: 21.17,
    x2: 90.7,
    y2: 23.19
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 84.69,
    y1: 15.53,
    x2: 90.25,
    y2: 12.98
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 80.56,
    y1: 11.78,
    x2: 82.67,
    y2: 6
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 75.01,
    y1: 12.01,
    x2: 72.38,
    y2: 6.45
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 71.18,
    y1: 16.14,
    x2: 65.47,
    y2: 14.03
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 71.48,
    y1: 21.69,
    x2: 65.93,
    y2: 24.32
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 75.61,
    y1: 25.52,
    x2: 73.51,
    y2: 31.23
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.28,18.23c0,2.72-1.67,4.88-3.77,4.88a3.85,3.85,0,0,1-3.35-2.72,7.47,7.47,0,0,1-2.93.56c-3.67,0-6.61-2.34-6.61-5.15a4.71,4.71,0,0,1,1.58-3.37v-.38A4.94,4.94,0,0,1,16.81,6.9,4.61,4.61,0,0,1,18,7.09a4.39,4.39,0,0,1,3.88-2.25A4.88,4.88,0,0,1,26.45,10,5.9,5.9,0,0,1,25,13.83,4.86,4.86,0,0,1,27.28,18.23Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRenovationModernisationV23);
export default __webpack_public_path__ + "static/media/icon_renovation-modernisation_v2.3.9efeade6af24b15694b52b33ab0638be.svg";
export { ForwardRef as ReactComponent };